var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOfficeIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#242E30",
  d: "M15.469 2.617H4.53a1.925 1.925 0 0 0-1.914 1.914v12.852h14.766V4.53a1.925 1.925 0 0 0-1.914-1.914m.273 13.125H10.82v-2.46H9.18v2.46H4.258V4.532a.273.273 0 0 1 .273-.274H15.47a.273.273 0 0 1 .273.273zm-4.648-8.75h2.187v1.64h-2.187zm-4.375 0h2.187v1.64H6.72zm4.375 3.281h2.187v1.641h-2.187zm-4.375 0h2.187v1.641H6.72z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgOfficeIcon);
export default ForwardRef;